import React from 'react'
import classNames from 'classnames'
import { useIntl } from 'react-intl'

import type { Icon } from '@slite/icons'
import {
  AppsIcon,
  CommentsEmptyIcon,
  DocCardIcon,
  SearchIcon,
} from '@slite/icons'

import { useRoutes } from '../../routes'

type IntegrationsSidebarCurrent = 'all' | 'document-embed' | 'source' | 'client'

export function IntegrationsSidebar({
  current,
}: {
  current: IntegrationsSidebarCurrent
}) {
  const intl = useIntl()
  const routes = useRoutes()

  const options: {
    value: IntegrationsSidebarCurrent
    label: string
    href: string
    icon: Icon
  }[] = [
    {
      value: 'all',
      label: intl.formatMessage({
        id: 'integrations.integrationTypeNav.all',
        defaultMessage: 'All integrations',
      }),
      href: routes.integrations.index(),
      icon: AppsIcon,
    },
    {
      value: 'source',
      label: intl.formatMessage({
        id: 'integrations.integrationTypeNav.source',
        defaultMessage: 'Sources you search',
      }),
      href: routes.integrations.sources(),
      icon: SearchIcon,
    },
    {
      value: 'client',
      label: intl.formatMessage({
        id: 'integrations.integrationTypeNav.client',
        defaultMessage: 'Where you call Slite from',
      }),
      href: routes.integrations.clients(),
      icon: CommentsEmptyIcon,
    },
    {
      value: 'document-embed',
      label: intl.formatMessage({
        id: 'integrations.integrationTypeNav.documentEmbed',
        defaultMessage: 'Document embeds',
      }),
      href: routes.integrations.documentIntegrations(),
      icon: DocCardIcon,
    },
  ]

  return (
    <div
      className="flexbox flexbox-column flexbox-align-start position-sticky"
      style={{ top: 100 }}
    >
      {options.map((option) => {
        const Icon = option.icon
        return (
          <a
            key={option.value}
            href={option.href}
            className={classNames(
              'flexbox flexbox-align-center flexbox-gap-12 text-align-left font-size-9 font-family-system padding-vertical-8 padding-horizontal-16 margin-bottom-4 radius-largest transition font-weight-semibold',
              current === option.value
                ? 'background-moon-dust-darker shade-05 shade-05-on-hover'
                : 'background-transparent shade-10 shade-20-on-hover'
            )}
          >
            <Icon size={18} />
            {option.label}
          </a>
        )
      })}
    </div>
  )
}
